/**
 * OrbDocDownloadsSkillsSLOrbDocDownloadsSkillsSLPage
 *
 * Page component for OrbDocDownloadsSkillsSLOrbDocDownloadsSkillsSLPage
 * Path: /sl/docs/downloads/skills
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocDownloadsSkillsSLDocScreenView as __OrbDocDownloadsSkillsSLDocScreenView } from '@/components/traits/OrbDocDownloadsSkillsSLDocScreenView';
import { OrbDocDownloadsSkillsSLDocAnalyticsView as __OrbDocDownloadsSkillsSLDocAnalyticsView } from '@/components/traits/OrbDocDownloadsSkillsSLDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocDownloadsSkillsSLOrbDocDownloadsSkillsSLPageProps {
  // Add any page-level props here
}

export function OrbDocDownloadsSkillsSLOrbDocDownloadsSkillsSLPage(_props: OrbDocDownloadsSkillsSLOrbDocDownloadsSkillsSLPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Veščine agentov","description":"Naj vsak programerski agent piše veljaven .lolo, z istim katalogom in preverjanji, kot jih uporablja prevajalnik.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/downloads/skills"},{"locale":"ar","path":"/ar/docs/downloads/skills"},{"locale":"sl","path":"/sl/docs/downloads/skills"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocDownloadsSkillsSLDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocDownloadsSkillsSLDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocDownloadsSkillsSLOrbDocDownloadsSkillsSLPage;
